import { gql } from '@grandvisionhq/graphql';
import { deliveryEstimationResponse } from '../fragments/delivery-estimation.js';

const GET_DELIVERY_ESTIMATION = gql`
  query GetDeliveryEstimation($input: EstimatedDeliveryBySkuInput!) {
    deliveryEstimation(input: $input) {
      ...DeliveryEstimationResponseFragment
    }
  }
  ${deliveryEstimationResponse}
`;

export { GET_DELIVERY_ESTIMATION };
//# sourceMappingURL=get-delivery-estimation.js.map
